/**
 * Maps an enabled key to each object in an array
 * @param {Array} arr - The array of objects to map enabled to
 *   @param {Object} arr.obj - An object to add the enabled key to
 * @returns {Array} new mapped array containing the same objects passed in, but with an enabled key 
 */
export function mapEnabled (arr) {
  return arr.map(function (item) {
    return {
      ...item,
      enabled: false
    };
  });
}


// WEBPACK FOOTER //
// ./resources/assets/js/app/store/services/mapEnabled.js